export const getAspectsWithInclude = (data, include) => data?.map(({ aspectName, params }) => ({
    aspectName,
    params: aspectName === 'mindboxEvent' ? { ...params, eventJson: include } : params,
}));
//# sourceMappingURL=getAspectsWithInclude.js.map